import { render, staticRenderFns } from "./TicketOk.vue?vue&type=template&id=5e2a4b74&scoped=true&"
import script from "./TicketOk.vue?vue&type=script&lang=js&"
export * from "./TicketOk.vue?vue&type=script&lang=js&"
import style0 from "./TicketOk.vue?vue&type=style&index=0&id=5e2a4b74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2a4b74",
  null
  
)

export default component.exports